import { FC, useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import {
  SNIPPETS_ROUTE,
  SNIPPETS_TEAM_ROUTE,
  TEAM_SETTINGS_ROUTE,
  TEMPLATES_ROUTE,
  TEMPLATES_TEAM_ROUTE,
  QUICK_RECORDINGS_ROUTE,
  WORKSPACE_ROUTE,
  redirectActions,
  QUICK_RECORDINGS_MY_ROUTE,
  PAGES_OVERVIEW_ROUTE,
  CALL_RECORDINGS_ROUTE,
} from '../../../entities/history';
import { matchPath, useLocation } from 'react-router-dom';
import { navigate } from '../../../processes/navigation';
import { WorkspaceNavigationItem } from './WorkspaceNavigationItem';

import { Item } from './types';
import { IconMap } from '../../../shared/sprite';

export enum ItemId {
  EMPTY = '',
  ALL = 'all',
  OVERVIEW = 'overview',
  ANALYTICS = 'analytics',
  LEADS = 'leads',
  SETTINGS = 'settings',
  QUICK_RECORDINGS = 'quick-recordings',
  CALL_RECORDINGS = 'call-recordings',
  TEMPLATES = 'templates',
  SNIPPETS = 'snippets',
}

export const WorkspaceNavigation: FC = () => {
  const dispatch = useDispatch();

  const [current, setCurrent] = useState(ItemId.EMPTY);

  const location = useLocation();

  const items: Item<ItemId>[] = [
    {
      id: ItemId.OVERVIEW,
      label: 'Overview',
      icon: IconMap.BarChartSquare01,
      onClick: () => {
        dispatch(redirectActions.toPagesOverview());
        setCurrent(ItemId.OVERVIEW);
      },
    },
    {
      id: ItemId.ALL,
      label: 'All pages',
      icon: IconMap.Files,
      onClick: () => {
        dispatch(redirectActions.toWorkspace());
        setCurrent(ItemId.ALL);
      },
    },
    {
      id: ItemId.QUICK_RECORDINGS,
      label: 'Video recordings',
      icon: IconMap.Records,
      onClick: () => {
        dispatch(navigate({ to: QUICK_RECORDINGS_MY_ROUTE }));
        setCurrent(ItemId.QUICK_RECORDINGS);
      },
    },
    {
      id: ItemId.CALL_RECORDINGS,
      label: 'Call recordings',
      icon: IconMap.HeadPhones02,
      onClick: () => {
        dispatch(navigate({ to: CALL_RECORDINGS_ROUTE }));
        setCurrent(ItemId.CALL_RECORDINGS);
      },
    },
    {
      id: ItemId.TEMPLATES,
      label: 'Templates',
      icon: IconMap.Templates,
      onClick: () => {
        dispatch(navigate({ to: TEMPLATES_TEAM_ROUTE }));
        setCurrent(ItemId.TEMPLATES);
      },
      className: 'md:hidden',
    },
    {
      id: ItemId.SNIPPETS,
      label: 'Snippets',
      icon: IconMap.Snippets,
      onClick: () => {
        dispatch(navigate({ to: SNIPPETS_TEAM_ROUTE }));
        setCurrent(ItemId.SNIPPETS);
      },
      className: 'md:hidden',
    },
  ];

  const isAll = location.pathname === WORKSPACE_ROUTE;
  const isTeamSettings = matchPath(location.pathname, {
    path: TEAM_SETTINGS_ROUTE,
  });
  const isTemplates = matchPath(location.pathname, {
    path: TEMPLATES_ROUTE,
  });
  const isSnippets = matchPath(location.pathname, {
    path: SNIPPETS_ROUTE,
  });
  const isQuickRecordings = matchPath(location.pathname, {
    path: QUICK_RECORDINGS_ROUTE,
  });
  const isPageOverview = matchPath(location.pathname, {
    path: PAGES_OVERVIEW_ROUTE,
  });
  const isCallRecordings = matchPath(location.pathname, {
    path: CALL_RECORDINGS_ROUTE,
  });

  useEffect(() => {
    setCurrent(ItemId.EMPTY);
    isAll && setCurrent(ItemId.ALL);
    isTeamSettings && setCurrent(ItemId.SETTINGS);
    isTemplates && setCurrent(ItemId.TEMPLATES);
    isSnippets && setCurrent(ItemId.SNIPPETS);
    isQuickRecordings && setCurrent(ItemId.QUICK_RECORDINGS);
    isPageOverview && setCurrent(ItemId.OVERVIEW);
    isCallRecordings && setCurrent(ItemId.CALL_RECORDINGS);
  }, [
    isTeamSettings,
    isAll,
    isTemplates,
    isSnippets,
    isQuickRecordings,
    isPageOverview,
    isCallRecordings,
  ]);

  return (
    <div className="flex flex-col">
      {items.map((item) => (
        <WorkspaceNavigationItem
          key={item.id}
          label={item.label}
          icon={item.icon}
          onClick={item.onClick}
          isActive={item.id === current}
          className={item.className}
        />
      ))}
    </div>
  );
};
